<template>
  <div class="gohome" @click="gohome()"></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    gohome() {
      this.$router.push('/')
    },
  },
}
</script>
 
<style lang="less" scoped>
.gohome {
  //   position: absolute;
  bottom: 0;
  margin-top: 2rem;
  margin: 0 auto;
  //   left: 50%;
  //   transform: translateX(-50%);
  width: 9.5rem;
  height: 1.66rem;
  background: url('../../static//images//Home/bt2.png') no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Gohome.vue